// Display helpers ported verbatim from admin.html / platform.html so number
// and date formatting stay byte-identical to the legacy UI.

export function fmtNum(n: number | null | undefined): string {
  if (n === null || n === undefined || Number.isNaN(n)) return "—";
  if (n >= 1_000_000) return (n / 1_000_000).toFixed(1) + "M";
  if (n >= 1_000) return (n / 1_000).toFixed(1) + "k";
  return String(n);
}

export function fmtDate(iso: string | null | undefined): string {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return "—";
    return d.toLocaleDateString("fr-FR", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  } catch {
    return "—";
  }
}

// HTML escape — used in places where we render user data through
// dangerouslySetInnerHTML. Prefer JSX rendering; this is here for parity.
export function esc(s: unknown): string {
  if (s === null || s === undefined) return "";
  return String(s)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}

// Password generator — matches admin.html behavior. 16 chars with at least
// one lowercase, uppercase, digit, and symbol.
export function generatePassword(length = 16): string {
  const lower = "abcdefghijklmnopqrstuvwxyz";
  const upper = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  const digit = "0123456789";
  const symbol = "!@#$%^&*";
  const all = lower + upper + digit + symbol;
  const pick = (s: string) => s[Math.floor(Math.random() * s.length)]!;
  while (true) {
    const chars = [pick(lower), pick(upper), pick(digit), pick(symbol)];
    for (let i = chars.length; i < length; i++) chars.push(pick(all));
    // Fisher-Yates shuffle
    for (let i = chars.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [chars[i], chars[j]] = [chars[j]!, chars[i]!];
    }
    return chars.join("");
  }
}
